export enum CardCondition {
  NEAR_MINT = 'NEAR_MINT',
  SLIGHTLY_PLAYED = 'SLIGHTLY_PLAYED',
  MODERATELY_PLAYED = 'MODERATELY_PLAYED',
  HEAVILY_PLAYED = 'HEAVILY_PLAYED',
  DAMAGED = 'DAMAGED',
}
